import { baseErrorHandler } from '@queries/baseErrorHandler';
import { $api } from '@service/RequestService';
import { getOrdersBody } from '@utils/helper/getSearchAndDownloadBodyAllTables';
import { timeStampToDate } from '@utils/index';
import { CancelOrderReasonResponse, CancelReasonOrder } from '@utils/models/CancelReasonOrder';
import { OrderStatus } from '@utils/models/OrderStatus';
import { Order } from '@utils/models/OrderTable';
import { Pagination } from '@utils/models/Pagination';
import { useQuery } from 'react-query';

import { SearchParamsOrder } from '../Order';
import { endPoints } from '../utils/constants/endPoints';
import { queryKeys } from '../utils/constants/queryKeys';

// get booked flats list
export function useBookedFlats(searchObj: SearchParamsOrder) {
  return useQuery<Pagination<Order>>(
    [queryKeys.BOOKED_FLAT_LIST, searchObj.page, JSON.stringify(searchObj)],
    async () => {
      const res = await $api.post(endPoints.BOOKING_FILTER, getOrdersBody(searchObj));

      const data: Pagination<Order> = res?.data?.data;

      return {
        ...data,
        data: data?.data?.map(item => ({
          ...item,
          date: timeStampToDate({ date: item?.date, timeStamp: item?.dateTimestamp })
        }))
      };
    },
    {
      enabled: !!searchObj.page && !!searchObj.size
    }
  );
}

export function useOneOrderCancelReason(id: string, status: OrderStatus) {
  return useQuery<CancelOrderReasonResponse>(
    [queryKeys.ORDER_CANCEL_REASON_ID, id],
    async () => {
      const res = await $api.get(`${endPoints.BOOKING_CANCEL_REASON}/${id}`);

      return res?.data?.data;
    },
    {
      enabled: status === OrderStatus.CANCELED,
      refetchOnWindowFocus: false,
      onError: baseErrorHandler,
      refetchInterval: Infinity,
      retry: false
    }
  );
}

export function useOrderCancelReason(companyId?: number) {
  return useQuery<CancelReasonOrder[]>(
    [queryKeys.ORDER_CANCEL_REASON, companyId],
    async () => {
      const res = await $api.get(endPoints.BOOKING_CANCEL_REASON + (companyId ? `?companyId=${companyId}` : ''));

      return res?.data?.data;
    },
    {
      enabled: !!companyId,
      refetchOnWindowFocus: false,
      onError: baseErrorHandler,
      refetchInterval: Infinity,
      retry: false
    }
  );
}
